import { navigate } from "gatsby"
import React, { Component, useState } from "react"
import NewsletterSignUp from "./NewsletterSignUp"
import { PRICING, getPricing, PRODUCT_META } from "../config/pricing"

// StandDesignerFree Component - FREE download with signup form
class StandDesignerFree extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seats: "",
      firstName: "",
      lastName: "",
      email: "",
      isSubmitting: false,
      message: "",
      status: null,
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ isSubmitting: true, message: "" })

    const { seats, firstName, lastName, email } = this.state

    // Validate required fields
    if (!seats || !firstName || !email) {
      this.setState({
        isSubmitting: false,
        message: "Please fill in all required fields.",
        status: "error",
      })
      return
    }

    try {
      // TODO: Implement backend endpoint for free download signup
      // For now, simulate success and trigger download
      console.log("Stand Designer Free signup:", { seats, firstName, lastName, email })

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000))

      this.setState({
        isSubmitting: false,
        message: "Success! Your download will begin shortly.",
        status: "success",
        seats: "",
        firstName: "",
        lastName: "",
        email: "",
      })

      // TODO: Trigger actual download or redirect to download page
      // window.location.href = "/downloads/stand-designer"
    } catch (error) {
      this.setState({
        isSubmitting: false,
        message: "An error occurred. Please try again.",
        status: "error",
      })
    }
  }

  render() {
    const { product } = this.props
    const { seats, firstName, lastName, email, isSubmitting, message, status } = this.state

    return (
      <div className="product-card stand-designer-free">
        <div className="product-header">
          <img
            className="product-icon"
            src={product?.icon?.sourceUrl}
            alt={product?.icon?.altText}
          />
          <h2 className="product-title">
            {product?.heading?.brand}{" "}
            <strong>{product?.heading?.name}</strong>
          </h2>
        </div>

        <div className="product-image">
          <img
            src={product?.image?.sourceUrl}
            alt={product?.image?.altText}
          />
        </div>

        <div className="free-signup-form">
          <div className="free-header">
            <strong className="free-title">FREE</strong>
            <span className="free-subtitle">SIGN UP TO DOWNLOAD</span>
          </div>

          <form onSubmit={this.handleSubmit}>
            <div className="form-field">
              <label htmlFor="seats">Seats (Qty)*</label>
              <input
                type="number"
                id="seats"
                name="seats"
                min="1"
                placeholder="0"
                value={seats}
                onChange={this.handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label htmlFor="firstName">First Name*</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="Enter First Name"
                value={firstName}
                onChange={this.handleChange}
                required
              />
            </div>

            <div className="form-field">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Enter Last Name"
                value={lastName}
                onChange={this.handleChange}
              />
            </div>

            <div className="form-field">
              <label htmlFor="email">Email*</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter Email"
                value={email}
                onChange={this.handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className="button button-dark download-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : "DOWNLOAD"}
            </button>

            {message && (
              <div className={`form-message ${status}`}>
                {message}
              </div>
            )}
          </form>
        </div>

        {/* Product Tabs */}
        <BuyNowTabs
          features={product?.productFeatures}
          requirements={product?.systemRequirements}
        />
      </div>
    )
  }
}

// ProductCard Component - handles individual product with its own state
class ProductCard extends Component {
  constructor(props) {
    super(props)
    // Get default prices from pricing config
    const productPricing = PRICING[props.productType] || PRICING['stand-designer']
    this.state = {
      quantity: 0,
      yearlyQuantity: 0,
      monthlyQuantity: 0,
      yearlyPrice: productPricing.yearly.tier1.price,
      monthlyPrice: productPricing.monthly.tier1.price,
      yearlySavings: 0,
      monthlySavings: 0,
    }
  }

  handleChange = (interval, quantity) => {
    const qty = quantity ? parseInt(quantity) : 0
    this.calculatePrice(interval, qty)
  }

  // Handle quantity change for free products
  handleFreeQuantityChange = (quantity) => {
    const qty = quantity ? parseInt(quantity) : 0
    this.setState({ quantity: qty })
  }

  addToCart = (interval) => {
    if (typeof window !== "undefined") {
      const productMeta = PRODUCT_META[this.props.productType]
      const isFree = productMeta?.isFree || false

      // For free products, use the single quantity field
      const quantity = isFree
        ? this.state.quantity
        : (interval === "yearly" ? this.state.yearlyQuantity : this.state.monthlyQuantity)
      const price = isFree
        ? 0
        : (interval === "yearly" ? this.state.yearlyPrice : this.state.monthlyPrice)
      const savings = isFree
        ? 0
        : (interval === "yearly" ? this.state.yearlySavings : this.state.monthlySavings)

      localStorage.setItem(
        "vf-cart",
        JSON.stringify({
          price: price,
          quantity: quantity,
          interval: isFree ? 'free' : interval, // Mark as 'free' for free products
          savings: savings,
          product: this.props.productType, // 'stand-designer' or 'vf-pro'
          isFree: isFree,
        })
      )
      navigate("/checkout/cart")
    }
  }

  calculatePrice = (interval, quantity) => {
    // Use pricing config based on product type
    const productType = this.props.productType || 'stand-designer'
    const productPricing = PRICING[productType]

    let price
    let savings

    if (quantity >= 10) {
      const tier = productPricing[interval].tier3
      price = tier.price
      savings = tier.savings
    } else if (quantity > 1 && quantity < 10) {
      const tier = productPricing[interval].tier2
      price = tier.price
      savings = tier.savings
    } else if (quantity === 1) {
      const tier = productPricing[interval].tier1
      price = tier.price
      savings = tier.savings
    } else {
      const tier = productPricing[interval].tier1
      price = tier.price
      savings = 0
      quantity = 0
    }

    const finalSavings = savings > 0 ? savings * quantity : 0

    if (interval === 'yearly') {
      this.setState({
        yearlyQuantity: quantity,
        yearlyPrice: price,
        yearlySavings: finalSavings,
      })
    } else {
      this.setState({
        monthlyQuantity: quantity,
        monthlyPrice: price,
        monthlySavings: finalSavings,
      })
    }
  }

  render() {
    const { product, productType } = this.props
    // Get pricing tiers from config
    const pricing = PRICING[productType] || PRICING['stand-designer']
    const productMeta = PRODUCT_META[productType]
    const isFree = productMeta?.isFree || false

    // Render FREE product card
    if (isFree) {
      return (
        <div className="product-card product-card-free">
          <div className="product-header">
            <img
              className="product-icon"
              src={product?.icon?.sourceUrl}
              alt={product?.icon?.altText}
            />
            <h2 className="product-title">
              {product?.heading?.brand}{" "}
              <strong>{product?.heading?.name}</strong>
            </h2>
          </div>

          <div className="product-image">
            <img
              src={product?.image?.sourceUrl}
              alt={product?.image?.altText}
            />
          </div>

          <div className="free-pricing-wrapper">
            <div className="free-badge">
              <strong className="free-title">
                {PRODUCT_META[productType]?.isBeta ? 'BETA' : 'FREE'}
              </strong>
            </div>

            {PRODUCT_META[productType]?.isBeta && (
              <div className="beta-notice">
                <p>Beta access requires a code. You'll enter it during checkout.</p>
              </div>
            )}

            <div className="quantity-input">
              <label>Seats (Qty)</label>
              <input
                type="number"
                placeholder="0"
                min="1"
                value={this.state.quantity || ""}
                onChange={(e) => this.handleFreeQuantityChange(e.target.value)}
              />
            </div>

            <button
              className="button button-dark add-to-cart-btn"
              disabled={!this.state.quantity || this.state.quantity < 1}
              onClick={() => this.addToCart("free")}
            >
              {PRODUCT_META[productType]?.isBeta ? 'Unlock Beta Access' : 'Get Started'}
            </button>
          </div>

          {/* Product Tabs */}
          <BuyNowTabs
            features={product?.productFeatures}
            requirements={product?.systemRequirements}
          />
        </div>
      )
    }

    // Render paid product card (original behavior)
    return (
      <div className="product-card">
        <div className="product-header">
          <img
            className="product-icon"
            src={product?.icon?.sourceUrl}
            alt={product?.icon?.altText}
          />
          <h2 className="product-title">
            {product?.heading?.brand}{" "}
            <strong>{product?.heading?.name}</strong>
          </h2>
        </div>

        <div className="product-image">
          <img
            src={product?.image?.sourceUrl}
            alt={product?.image?.altText}
          />
        </div>

        <div className="pricing-options-wrapper">
          {/* Yearly Option */}
          <div className="pricing-option yearly">
            <div className="option-header">
              <strong>YEARLY</strong>
            </div>

            <div className="pricing-tiers">
              <div className="tier">
                <span>1 seat</span>
                <span className="price">${this.state.yearlyQuantity === 1 ? this.state.yearlyPrice : pricing.yearly.tier1.price} (per seat/yr)</span>
              </div>
              <div className="tier">
                <span>2-9 seats</span>
                <span className="price">
                  ${this.state.yearlyQuantity >= 2 && this.state.yearlyQuantity <= 9 ? this.state.yearlyPrice : pricing.yearly.tier2.price} (per seat/yr)
                </span>
              </div>
              <div className="tier">
                <span>10+ seats</span>
                <span className="price">
                  ${this.state.yearlyQuantity >= 10 ? this.state.yearlyPrice : pricing.yearly.tier3.price} (per seat/yr)
                </span>
              </div>
            </div>

            <div className="quantity-input">
              <label>Seats (Qty)</label>
              <input
                type="number"
                placeholder="0"
                min="0"
                value={this.state.yearlyQuantity || ""}
                onChange={(e) => this.handleChange("yearly", e.target.value)}
              />
            </div>

            <button
              className="button button-dark add-to-cart-btn"
              disabled={!this.state.yearlyQuantity || this.state.yearlyQuantity < 1}
              onClick={() => this.addToCart("yearly")}
            >
              Add to cart
            </button>

            {this.state.yearlySavings > 0 && (
              <div className="savings">
                Savings: ${this.state.yearlySavings}
              </div>
            )}
          </div>

          {/* Monthly Option */}
          <div className="pricing-option monthly">
            <div className="option-header">
              <strong>MONTHLY</strong>
            </div>

            <div className="pricing-tiers">
              <div className="tier">
                <span>1 seat</span>
                <span className="price">${this.state.monthlyQuantity === 1 ? this.state.monthlyPrice : pricing.monthly.tier1.price} (per seat/mo)</span>
              </div>
              <div className="tier">
                <span>2-9 seats</span>
                <span className="price">
                  ${this.state.monthlyQuantity >= 2 && this.state.monthlyQuantity <= 9 ? this.state.monthlyPrice : pricing.monthly.tier2.price} (per seat/mo)
                </span>
              </div>
              <div className="tier">
                <span>10+ seats</span>
                <span className="price">
                  ${this.state.monthlyQuantity >= 10 ? this.state.monthlyPrice : pricing.monthly.tier3.price} (per seat/mo)
                </span>
              </div>
            </div>

            <div className="quantity-input">
              <label>Seats (Qty)</label>
              <input
                type="number"
                placeholder="0"
                min="0"
                value={this.state.monthlyQuantity || ""}
                onChange={(e) => this.handleChange("monthly", e.target.value)}
              />
            </div>

            <button
              className="button button-dark add-to-cart-btn"
              disabled={!this.state.monthlyQuantity || this.state.monthlyQuantity < 1}
              onClick={() => this.addToCart("monthly")}
            >
              Add to cart
            </button>

            {this.state.monthlySavings > 0 && (
              <div className="savings">
                Savings: ${this.state.monthlySavings}
              </div>
            )}
          </div>
        </div>

        {/* Product Tabs */}
        <BuyNowTabs
          features={product?.productFeatures}
          requirements={product?.systemRequirements}
        />
      </div>
    )
  }
}

// Main BuyNow Component
class BuyNow extends Component {
  constructor(props) {
    super(props)
    const { fields } = props
    this.state = {
      fields: fields,
    }
  }

  render() {
    const { fields } = this.state

    // Build product data from new ACF fields
    const standDesigner = fields?.standDesigner ? {
      productType: "stand-designer",
      icon: fields.standDesigner.icon,
      heading: {
        brand: fields.standDesigner.headingBrand,
        name: fields.standDesigner.headingName,
      },
      image: fields.standDesigner.productImage,
      productFeatures: fields.standDesigner.productFeatures,
      systemRequirements: fields.standDesigner.systemRequirements,
    } : null

    const vfPro = fields?.vfPro ? {
      productType: "vf-pro",
      icon: fields.vfPro.icon,
      heading: {
        brand: fields.vfPro.headingBrand,
        name: fields.vfPro.headingName,
      },
      image: fields.vfPro.productImage,
      productFeatures: fields.vfPro.productFeatures,
      systemRequirements: fields.vfPro.systemRequirements,
    } : null

    return (
      <div className="buy-now-wrap">
        {fields?.showProducts && (standDesigner || vfPro) ? (
          <div className="buy-now-products">
            <div className="container">
              <div className="products-grid">
                {vfPro && (
                  <ProductCard product={vfPro} productType="vf-pro" />
                )}
                {standDesigner && (
                  <ProductCard product={standDesigner} productType="stand-designer" />
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    )
  }
}

const BuyNowTabs = (data) => {
  const [activeTab, setActiveTab] = useState(0)

  const changeTab = (index) => {
    setActiveTab(index)
  }

  return (
    <React.Fragment>
      <div className="buy-now-tabs">
        <div className="tabs-container">
          <button
            className={`tab ${activeTab === 0 ? "active" : ""}`}
            onClick={() => changeTab(0)}
          >
            {data?.features?.title || "Product Features"}
          </button>
          <button
            className={`tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => changeTab(1)}
          >
            {data?.requirements?.title || "System Requirements"}
          </button>
        </div>
      </div>
      <div className="buy-now-tab-content">
        <div className={`content ${activeTab === 0 ? "active" : ""}`}>
          <div className="tab-content-container">
            <ul>
              {data?.features?.features &&
                data?.features?.features.map((feature, index) => {
                  return <li key={index}>{feature?.feature}</li>
                })}
            </ul>
          </div>
        </div>
        <div className={`content ${activeTab === 1 ? "active" : ""}`}>
          <div className="tab-content-container">
            <table>
              <tbody>
                {data?.requirements?.requirements &&
                  data?.requirements?.requirements.map((row, index) => {
                    return (
                      <tr key={`requirements-${index}`}>
                        <td>{row?.col1}</td>
                        <td>{row?.col2}</td>
                        <td>{row?.col3}</td>
                      </tr>
                    )
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default BuyNow
